import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

const useDeleteInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) =>
      api.call(`/invitations/${id}`, {
        method: "DELETE",
        root: supportApiBase,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.invitations());
      },
    }
  );
};

export default useDeleteInvitation;
